var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76689 11.2334H2.66689C2.05939 11.2334 1.56689 10.7409 1.56689 10.1333V2.66665C1.56689 2.05913 2.05938 1.56665 2.66689 1.56665H10.1336C10.7411 1.56665 11.2336 2.05914 11.2336 2.66665V4.26661V4.76661H11.7336H13.3336C13.9411 4.76661 14.4336 5.2591 14.4336 5.86661V13.3333C14.4336 13.9407 13.941 14.4333 13.3336 14.4333H5.86689C5.25939 14.4333 4.76689 13.9407 4.76689 13.3333V12.2334V11.7334V10.6667V10.1667V5.86661C4.76689 5.25909 5.25939 4.76661 5.86689 4.76661H10.6669H11.1669V4.26661V2.66665C11.1669 2.09596 10.7043 1.63332 10.1336 1.63332H2.66689C2.0962 1.63332 1.63356 2.09596 1.63356 2.66665V10.1333C1.63356 10.704 2.09615 11.1667 2.66689 11.1667H3.76689V11.2334ZM5.86689 4.83327C5.2962 4.83327 4.83356 5.29592 4.83356 5.86661V13.3333C4.83356 13.904 5.29624 14.3666 5.86689 14.3666H13.3336C13.9041 14.3666 14.3669 13.9041 14.3669 13.3333V5.86661C14.3669 5.29589 13.9042 4.83327 13.3336 4.83327H5.86689Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.582b843372b58927a7864568b1377083.svg";
export { ForwardRef as ReactComponent };